export default __webpack_public_path__ + "static/media/IMG0284.93d1fdc7.jpg";